import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

interface Data {
    token: string;
}

@Injectable()
export class TokenService {
    tokenUpdated$ = new Subject();
    data: Data = {
        token: ''
    };

    constructor() {}

    getToken(matrixParams: any = {}, queryParams: any = {}, token = 't') {
    // Reset token
        this.data.token = '';

        // Check if either one of the params objects have a token and set it
        if (matrixParams.hasOwnProperty(token)) {
            this.setToken(matrixParams[token]);

        } else if (queryParams.hasOwnProperty(token)) {
            this.setToken(queryParams[token]);
        }
    }

    // Get traditional query string token through location
    getQueryToken(token = 't') {
        const search = this.getSearch().replace('?', '').split('&');

        search.map((item: any) => {
            const vals = item.split('=');

            if (vals[0] === token) {
                this.setToken(vals[1]);

            } else {
                this.tokenUpdated$.error('Failed to get token');
            }
        });
    }

    setToken(token: string) {
        this.data.token = token;
        this.tokenUpdated$.next(true);
    }

    isTokenPresent() {
        return this.data.token.length > 0;
    }

    private getSearch(): string {
        return location.search;
    }
}
